import { render, staticRenderFns } from "./MilestoneTemplateEditForm.vue?vue&type=template&id=fa7cba9e&"
import script from "./MilestoneTemplateEditForm.vue?vue&type=script&lang=js&"
export * from "./MilestoneTemplateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports